module.exports = __webpack_public_path__ + "img/posIcon.c84c0b9c.svg";